<template>
  <div>
    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <!-- <p class="modal-card-title">Set fields for <b>{{roomData.name}}</b> room in <b>{{roomData.tag}}</b> configuration</p> -->
        <p class="modal-card-title">{{$t('index.set_room_fields_hotel',{roomname: roomData.name,roomtag: roomData.tag})}}</p>
      </header>

      <section class="modal-card-body roomfieldsbody">
        <b-table
          :data="resultFields"
          :loading="!resultFields.length"
          :striped="true"
          :narrowed="false"
          :mobile-cards="true"
          :paginated="false"
          :per-page="10"
          :pagination-simple="true"
          default-sort="['type', 'desc']"
        >
          <template slot-scope="props">
            <b-table-column
              field="name"
              :label="$t('index.name')"
              width="210"
            ><span>{{props.row.name}}</span>
            </b-table-column>

            <b-table-column
              :label="$t('index.value')"
              field="value"
              width="200"
            >
              <b-field>
                <b-input
                  v-if="props.row.value||props.row.type===1"
                  @input="setCustomValue($event,props.row,props.index)"
                  :disabled="isEditable(props.row.name)"
                  expanded
                  v-model="props.row.value"
                ></b-input>
              </b-field>

            </b-table-column>

            <b-table-column
              :label="$t('index.edit_by_customer')"
              field="edit"
              width="40"
              centered
            >
              <b-checkbox
                type="is-info"
                v-model="props.row.edit"
                :disabled="props.row.type!==1"
              ></b-checkbox>
            </b-table-column>

            <b-table-column
              field="tools"
              label=""
              width="40"
              centered
            >
              <button
                v-if="!isEditable(props.row.name)&&!props.row.defVal"
                @click="resetField(props.row)"
                class="button is-default"
                type="button"
              >{{$t('index.reset')}}</button>
            </b-table-column>
          </template>
        </b-table>
      </section>

      <footer class="modal-card-foot columns is-gapless">

        <div class="column is-half">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >{{$t('index.close')}}</button>
        </div>

        <div class="column is-half has-text-right">
          <button
            v-if="!validateCustomFieldError"
            class="button is-info"
            @click="saveFileds"
          >{{$t('index.save')}}</button>
        </div>

      </footer>
    </div>
  </div>
</template>

<script>
import FDateTime from './FDateTime.vue';

export default {
  props: ['roomData'],
  data() {
    return {
      validateCustomFieldError: false,
      resultFields: [],
      roomFieldId: 0,
      configFields: []
    };
  },
  methods: {
    getFields() {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/roomfields/get`,
        transformResponse: [
          data => {
            return JSON.parse(data);
          }
        ],
        data: this.roomData
      })
        .then(response => {
          if (response.data.status) {
            console.error(response.data.error);
            this.$snackbar.open({
              message: response.data.error,
              type: 'is-warning',
              position: 'is-bottom-right',
              actionText: 'Add fields',
              indefinite: true,
              container: 'div.modal-card',
              onAction: () => {
                this.$emit('create_config_fields', this.roomData);
                this.$parent.close();
              }
            });
          } else {
            this.resultFields = response.data.fields;
            this.configFields = response.data.configFields;
            this.roomFieldId = response.data.roomFieldId;
            console.log(response.data);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    setCustomValue(event, curField, indexField) {
      let defVal = false;
      this.configFields
        .filter(f => f.name == curField.name)
        .map(f => {
          defVal = f.value == event;
        });
      this.resultFields[indexField].defVal = defVal;
    },
    isEditable(name) {
      //console.log(name);
      switch (name) {
        case 'Configuration':
          return true;

        default:
          return false;
      }
    },
    deleteField(row) {
      this.resultFields.splice(this.resultFields.findIndex(item => item.name === row.name), 1);
    },
    saveFileds() {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/roomfields/save`,
        transformResponse: [
          data => {
            return JSON.parse(data);
          }
        ],
        data: {
          id: this.roomData.id,
          objectId: this.roomData.objectId,
          fields: this.resultFields,
          roomFieldId: this.roomFieldId
        }
      })
        .then(response => {
          if (response.data.status) {
            this.openNotificationWithType('danger', '', response.data.error);
          } else {
            if (response.data.fields) {
              this.getFields();
              this.$toast.open({
                message: this.$t('index.succesfully_saved'),
                position: 'is-bottom-right',
                type: 'is-success',
                container: 'div.modal-card'
              });
            }
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    resetField(field, deleteField = false) {
      this.$dialog.confirm({
        type: deleteField ? 'is-danger' : 'is-warning',
        message: deleteField ? this.$t('index.delete_this_field') : this.$t('index.reset_this_field'),
        onConfirm: () => {
          this.$http({
            method: 'post',
            url: `${this.$backendHost}/frontend/api/roomfields/reset`,
            transformResponse: [
              data => {
                return JSON.parse(data);
              }
            ],
            data: {
              roomData: this.roomData,
              field: field,
              roomFieldId: this.roomFieldId,
              deleteField: deleteField
            }
          })
            .then(response => {
              if (response.data.status) {
                // console.error(response.data.error);
                this.$snackbar.open({
                  message: response.data.error,
                  type: 'is-danger',
                  position: 'is-bottom-right',
                  actionText: 'Delete it',
                  indefinite: true,
                  container: 'div.modal-card',
                  onAction: () => {
                    // this.$parent.close();
                    this.resetField(field, true);
                  }
                });
              } else {
                if (response.data.fields) {
                  this.getFields();
                  this.$toast.open({
                    message: deleteField ? this.$t('index.field_successfully_deleted') : this.$t('index.field_successfully_reseted'),
                    position: 'is-bottom-right',
                    type: 'is-success',
                    container: 'div.modal-card'
                  });
                }
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    }
  },
  computed: {},
  mounted() {
    this.getFields();
  }
};
</script>

<style>
.modal-card .notices {
  padding: 0.5em;
}
.modal-card-body.roomfieldsbody {
  min-height: 250px;
}
</style>


// WEBPACK FOOTER //
// Roomfields.vue?47c92500